import React from 'react';
import { StyledModalCloseButton } from './styles';

export type ModalCloseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    color?: string;
};

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ color = '#c2c2c2', ...otherProps }) => (
    <StyledModalCloseButton type="button" aria-label="Close" {...otherProps}>
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 18 18"
            fillRule="evenodd"
            clipRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit={2}
        >
            <g fill={color}>
                <path d="M2.525.707a1 1 0 00-1.414 0l-.404.404a1 1 0 000 1.414l15.034 15.034a1 1 0 001.414 0l.404-.404a1 1 0 000-1.414L2.525.707z" />
                <path d="M15.741.707a1 1 0 011.414 0l.404.404a1 1 0 010 1.414L2.525 17.559a1 1 0 01-1.414 0l-.404-.404a1 1 0 010-1.414L15.741.707z" />
            </g>
        </svg>
        <span aria-hidden="true">×</span>
    </StyledModalCloseButton>
);

export default ModalCloseButton;
